import React, { Component } from 'react';
import { ShoppingBag, Store, Globe } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
type Segment = {
  icon: ComponentType<{
    className?: string;
    style?: React.CSSProperties;
  }>;
  label: string;
  description: string;
};
const segments: Segment[] = [{
  icon: ShoppingBag,
  label: 'E-commerce B2C',
  description: 'Brand e merchant che spediscono al consumatore finale.'
}, {
  icon: Store,
  label: 'Retail multi-store',
  description: 'Catene, franchising e brand con punti vendita propri.'
}, {
  icon: Globe,
  label: 'B2B e export',
  description: "Aziende che spediscono ad altre aziende, anche all'estero."
}];
export function ForWho() {
  return <section className="section-pad border-t border-default bg-elev1" id="per-chi" data-id="element-163">
      <div className="wrap" data-id="element-164">
        {/* Header */}
        <AnimatedSection data-id="element-165">
          <div className="max-w-[64ch] mb-12 md:mb-16" data-id="element-166">
            <div className="section-tag section-tag--accent mb-6" data-id="element-167">
              MODELLO DI DELIVERY
            </div>
            <h2 className="text-display-section mb-6" data-id="element-168">
              Aisac si adatta al tuo modello di delivery.
            </h2>
            <p className="text-body-lg color-ink-secondary" data-id="element-169">
              Che tu spedisca al consumatore finale, gestisca una rete di punti
              vendita o operi nel B2B internazionale, Aisac si integra con il
              tuo flusso operativo senza richiedere stravolgimenti.
            </p>
          </div>
        </AnimatedSection>

        {/* Cards */}
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-170">
          {segments.map(({
          icon: Icon,
          label,
          description
        }, i) => <AnimatedSection key={label} delay={0.1 + i * 0.1} data-id="element-171">
              <li className="flex flex-col gap-4 p-5 md:p-6 rounded-lg border border-default bg-[#0a0a0a] transition-colors duration-200 hover:border-[rgba(212,255,58,0.4)] h-full list-none" data-id="element-172">
                <Icon className="w-6 h-6" style={{
              color: 'var(--accent-500)'
            }} aria-hidden="true" data-id="element-173" />
                <div className="flex flex-col gap-1.5" data-id="element-174">
                  <span className="text-body-base color-ink-primary leading-snug font-medium" data-id="element-175">
                    {label}
                  </span>
                  <span className="text-body-sm color-ink-secondary leading-snug" data-id="element-176">
                    {description}
                  </span>
                </div>
              </li>
            </AnimatedSection>)}
        </ul>
      </div>
    </section>;
}